import { render, staticRenderFns } from "./GraphDetail87.vue?vue&type=template&id=545ac524&scoped=true"
import script from "./GraphDetail87.vue?vue&type=script&lang=js"
export * from "./GraphDetail87.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ac524",
  null
  
)

export default component.exports